import Consents from "@/views/Consents.vue";

export default [
  {
    path: "/consents",
    name: "consents",
    component: () => import("@/views/Default.vue"),
    props: {
      content: Consents,
    },
    meta: {
      requiredModule: "marketing-consents",
    },
  },
];
